<div class="notification-details-container">

  <owc-card class="notification-recepient-list" style="box-shadow: none;">

    <div class="notification-header">

      <div class="notification-list-title">Recipients</div>

      <div class="notification-details-search">
        <dl-notification-search (searchValue)="onSearchValue($event)"></dl-notification-search>
        <div title="Click to open filter Dialog" class="notification-details-filter-icon" (click)="filterData()">
            <owc-icon name="filter" family="outlined"></owc-icon>
            <span class="filter-text">Filter</span>
          </div>
      </div>

      <owc-modal-dialog [(ngModel)]="visibleFilterDialog" class="filter-dialog">
          <dl-filter-overlay-dialog [data]="data" (closed)="onFilterDialogClosed()"></dl-filter-overlay-dialog>
      </owc-modal-dialog>

      <div style="text-align: right; position: relative;" title="Click to configure columns">
        <owc-icon #settingsIcon class="one-icons" id="menu-anchor-1" name="settings" style="cursor: pointer;" (click)="toggleMenu($event)"></owc-icon>
        
        @if (menuVisible) {
        <div class="columns-dropdown-menu" [ngStyle]="dropdownPosition" (click)="$event.stopPropagation()">
          <div class="dropdown-header">
            <span class="dropdown-title">Show/Hide columns</span>
            <owc-icon name="chevron-up" style="cursor: pointer;" (click)="closeMenu()"></owc-icon>
          </div>
          
          <div class="dropdown-options">
            <div class="dropdown-option" (click)="masterToggle()">
              <owc-checkbox 
                style="height: 25px; pointer-events: none;"
                [checked]="isAllSelected()"
                [indeterminate]="hasValue() && !isAllSelected()">
              </owc-checkbox>
              <span class="option-label">All</span>
            </div>
            
            @for (element of dataSource; track $index) {
            <div class="dropdown-option" (click)="toggleSelection(element)">
              <owc-checkbox 
                style="pointer-events: none;"
                [checked]="isSelected(element)" 
                [disabled]="element.disabled">
              </owc-checkbox>
              <span class="option-label">{{element.key}}</span>
            </div>
            }
          </div>
          
          <div class="dropdown-footer">
            <owc-button color="primary" mat-flat-button (click)="getSelectedColumns()">Apply</owc-button>
          </div>
        </div>
        }
      </div>

    </div>

  </owc-card>

  <dl-notification-recipients-table *ngIf="showRecipientsTable" [isSetCom]="isSetCom" [isSetCancelled]="isSetCancelled" [notificationLabel]="notificationLabel"
    [contactDetails]="contactDataObj" [notificationDetails]="notificationDataObj"
    [selectedRecepientColumns]="selectedColumns" [accDataObj]="accDataObj"></dl-notification-recipients-table>

</div>